"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CustomModal = require("@ccw-pwa-ui/CustomModal");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const HeaderText = _ref => {
  let {
    headerText,
    headerStyle,
    navigationUrl,
    variant,
    image,
    userStatusData,
    statusModalShow,
    statusModalFlag,
    target
  } = _ref;
  const getStatusColor = colorVariant => {
    switch (colorVariant) {
      case "Active":
        return '#4A7B09';
      case "Invitation Expired":
        return '#E00932';
      case "Invitation Pending":
        return '#FA6400';
      case "Email Verification Pending":
        return '#FA6400';
      default:
        return '#0B3471';
    }
  };
  const getStyles = variant => {
    switch (variant) {
      case "header-text":
        return _objectSpread({
          color: '#0B3471',
          fontWeight: 600,
          fontSize: 32,
          fontFamily: 'Poppins'
        }, headerStyle);
      case "Invite-header-text":
        return {
          fontWeight: 400,
          fontSize: 16,
          fontFamily: 'Poppins',
          color: "".concat(getStatusColor(headerText))
        };
      case "link-text":
        return _objectSpread({
          color: '#0B3471',
          fontWeight: 600,
          fontSize: 32,
          textDecoration: 'none'
        }, headerStyle);
      case "simple-text":
        return _objectSpread({
          fontSize: 20,
          fontFamily: 'Poppins',
          fontWeight: 400,
          color: '#58595B'
        }, headerStyle);
      case "forgot-password-text":
        return _objectSpread({
          fontSize: 16,
          fontFamily: 'Poppins',
          fontWeight: 700,
          color: '#006E96'
        }, headerStyle);
      case "sub-text":
        return _objectSpread({
          fontSize: 16,
          fontFamily: 'Poppins',
          fontWeight: 400,
          color: '#333333'
        }, headerStyle);
      case "status-Btn":
        return {
          marginLeft: 19,
          marginBottom: 2
        };
      default:
        return {};
    }
  };
  return navigationUrl ? /*#__PURE__*/_react.default.createElement("a", {
    href: navigationUrl,
    style: getStyles(variant),
    target: target,
    rel: "noreferrer"
  }, headerText) : /*#__PURE__*/_react.default.createElement("span", {
    style: getStyles(variant)
  }, headerText, headerText === "Status" ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    onMouseOver: statusModalShow,
    onMouseOut: statusModalShow,
    style: getStyles('status-Btn'),
    alt: ""
  }), statusModalFlag ? /*#__PURE__*/_react.default.createElement(_CustomModal.CustomModal, {
    modalVariant: "statusModal",
    userStatusData: userStatusData
  }) : null) : null);
};
HeaderText.defaultProps = {
  target: "_blank"
};
var _default = exports.default = HeaderText;